<template>
  <header class="bracket-header">
    <div class="bracket-header__rounds-wrapper" ref="wrapper">
      <div class="bracket-header__rounds">
        <BracketHeaderRound
          v-for="round in rounds"
          :key="round"
          :round="round"
        />
      </div>
    </div>
    <div class="bracket-header__actions">
      <BracketHeaderBtn @click="scrollRoundLeft">
        <svg-icon icon-name="arrow-left" />
      </BracketHeaderBtn>
      <BracketHeaderBtn @click="scrollRoundRight">
        <svg-icon icon-name="arrow-right" />
      </BracketHeaderBtn>
    </div>
  </header>
</template>

<script>
import BracketHeaderRound from "./BracketHeaderRound";
import BracketHeaderBtn from "./BracketHeaderBtn";

const roundWidth = "330";

export default {
  name: "BracketHeader",

  components: {
    BracketHeaderRound,
    BracketHeaderBtn
  },

  props: {
    rounds: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    scroll(scrollLeft) {
      this.$refs.wrapper.scrollLeft = scrollLeft;
    },

    scrollRoundLeft() {
      const wrapper = this.$refs.wrapper;
      const rounds = Math.floor(wrapper.scrollLeft / roundWidth);
      const roundsWidth = roundWidth * rounds;
      const scrollLeft =
        wrapper.scrollLeft - roundsWidth > 50
          ? roundWidth * rounds
          : roundWidth * (rounds - 1);
      this.scroll(scrollLeft);
      this.$emit("scroll", scrollLeft);
    },

    scrollRoundRight() {
      const wrapper = this.$refs.wrapper;
      const rounds = Math.ceil(wrapper.scrollLeft / roundWidth);
      const roundsWidth = roundWidth * rounds;

      const scrollLeft =
        roundsWidth - wrapper.scrollLeft < 50
          ? roundWidth * (rounds + 1)
          : roundWidth * rounds;
      this.scroll(scrollLeft);
      this.$emit("scroll", scrollLeft);
    }
  }
};
</script>

<style lang="scss">
.bracket-header {
  position: relative;
  padding-top: 15px;
  margin-bottom: 30px;
  min-height: 44px;

  &__rounds-wrapper {
    max-width: 910px;
    overflow: hidden;
  }

  &__actions {
    position: absolute;
    right: 0;
    top: 0;
  }

  &__rounds {
    display: inline-flex;
    min-width: 100%;
    height: 100%;
    align-items: center;
  }

  @include breakpoint("lg-and-down") {
    padding-top: 60px;
  }
}
</style>
